<template>
	<AppLayout
		:title="trans('admin.users.boards.certificates.create.title', {years: board.years})"
		:return-url="route('association.boards.certificates.index')"
		:return-label="trans('admin.users.boards.certificates.title')"
	>
		<template #actions>
			<StoreCertificate
				certifiable-type="board"
				:certifiable-id="board.id"
				:return-url="route('association.boards.certificates.show', board.id)"
				:return-label="trans('admin.users.boards.certificates.create.title', {years: board.years})"
			/>
		</template>
		<CertificatesManager
			:certificates="certificates"
			:return-url="route('association.boards.certificates.show', board.id)"
			:return-label="trans('admin.users.boards.certificates.create.title', {years: board.years})"
		/>
	</AppLayout>
</template>
<script setup lang="ts">
import {route} from 'ziggy-js'
import {trans} from 'laravel-vue-i18n'
import {ref, type Ref, defineProps} from 'vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import {type Board} from '@/Types/Association/Boards/Board'
import {type Certificate} from '@/Types/Certificates/Certificate'
import StoreCertificate from '@/Components/Certificates/StoreCertificate.vue'
import CertificatesManager from '@/Components/Certificates/CertificatesManager.vue'

const props = defineProps<{
	board:Board,
	certificates:Array<Certificate>,
}>()

const board:Ref<Board> = ref(props.board)
const certificates:Ref<Array<Certificate>> = ref(props.certificates)
</script>